export default "__VITE_ASSET__e884c0f9__"